import { useEffect, useState } from 'react';
import { useAppNavigation } from 'hooks/useAppNavigation';
import { PrototypeMessageType, LOCAL_STORAGE_KEYS } from 'constant';
import { CONFIG } from 'config';
import { Logger } from 'utils/logger';
import { useWindowLocation } from 'hooks';

const allowedOrigin = CONFIG.BASE_URL;
const prototypeUrl = CONFIG.PROTOTYPE_URL;

const LOADER_DURATION = 9000;

export const usePrototypeTokenReceiver = () => {
  const { navigateTo } = useAppNavigation();
  const [isProcessingMessage, setIsProcessingMessage] = useState(false);
  const [receivedToken, setReceivedToken] = useState<string | null>(null);

  const { origin } = useWindowLocation();
  const isPrototypeServer = prototypeUrl === origin;

  useEffect(() => {
    if (isPrototypeServer) {
      setIsProcessingMessage(true);
    }
  }, [isPrototypeServer]);

  useEffect(() => {
    const handleTokenMessage = (event: MessageEvent) => {
      /**
       * Receive message only from the allowed origin i.e varicon domain
       */
      if (event.origin !== allowedOrigin) {
        setTimeout(() => {
          setIsProcessingMessage(false);
        }, LOADER_DURATION);
        return;
      }

      const { token } = event.data;

      if (token) {
        event.source?.postMessage(
          {
            type: PrototypeMessageType.TOKEN_RECEIVED,
            message: 'Token received and login successful',
          },
          { targetOrigin: event.origin },
        );

        Logger.info({
          message: 'Prototype Message: ',
          data: {
            origin: event.origin,
            message:
              'Token received and login successful. Sending Token Verification feedback..',
            type: PrototypeMessageType.TOKEN_RECEIVED,
          },
        });

        setReceivedToken(token);
        localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, token);
        navigateTo('/');
      }
    };

    setTimeout(() => {
      setIsProcessingMessage(false);
    }, LOADER_DURATION);

    window.addEventListener('message', handleTokenMessage);
    return () => {
      window.removeEventListener('message', handleTokenMessage);
    };
  }, [navigateTo]);

  return {
    isProcessingMessage,
    receivedToken,
  };
};
